/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_Gold_Ant_BaskInputs */

const en_green_gold_ant_bask = /** @type {(inputs: Green_Gold_Ant_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import could not be created`)
};

const de_green_gold_ant_bask = /** @type {(inputs: Green_Gold_Ant_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import konnte nicht erstellt werden`)
};

/**
* | output |
* | --- |
* | "Import could not be created" |
*
* @param {Green_Gold_Ant_BaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const green_gold_ant_bask = /** @type {((inputs?: Green_Gold_Ant_BaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_Gold_Ant_BaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_gold_ant_bask(inputs)
	return de_green_gold_ant_bask(inputs)
});